export class Question {
  _id: string;
  _created: number;
  timestamp: number;
  text: string;
  display_minute: string;
  relative_timestamp: number;

  type: string;

  activation: number;
  activation_relative_to: number;
  activation_milliseconds: number;

  duration: number;

  public constructor(init?: Partial<Question>) {
    Object.assign(this, init);
  }
}
